import React from 'react';
import { Link } from 'react-router-dom';
import bowleradventure from '../../images/bowlerAdventure.jpg';
import style from './card.module.css';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';

function Card({ visibleElements, elementsRef }) {
    return (
        <div className={`${style['card']}
        ${visibleElements.includes(elementsRef.current[19]) ?
                style['card--transition'] : ''}`}>
            <Link
                to='/bowler'
                className={style['card__link']}
                aria-label='Ver detalles de Bowler Adventure'
            >
                <div className={style['card__content']}>
                    <h3 className={style['card__title']}>Bowler Adventure</h3>
                    <p className={style['card__description']}>
                        Esquiva enemigos y derriba muchos pinos
                    </p>
                </div>
                <img
                    className={`lazyload ${style['card__image']}`}
                    src={bowleradventure}
                    alt='Imagen del juego Bowler Adventure'
                />
            </Link>
        </div>
    );
}

export default Card;
